import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home/Home';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Refs from './pages/References/References';
// Se cargan los segmentos de la web (los cuales se dividen en sus componentes).

function App() {
  return (
    <BrowserRouter >
      <Routes>
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/' element={<Home />} />
        <Route path='/refs' element={<Refs/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
